import React from "react";
import { Label } from "reactstrap";
import Select from "react-select";
import Required from "./Required";

const MultiSelect = ({
  title,
  name,
  placeholder,
  watch,
  errors,
  setValue,
  trigger,
  options,
  required = false,
  isClear = true,
}) => {
  const value = watch(name) || [];

  const handleChange = (selectedOptions) => {
    setValue(name, selectedOptions || [], {
      shouldValidate: true,
      shouldDirty: true,
    });
    trigger(name);
  };

  return (
    <div className="form-group" style={{ marginTop: "10px" }}>
      {title && (
        <Label className="form-label">
          {title}
          {required && <Required />}
        </Label>
      )}

      <Select
        isMulti
        isClearable={isClear}
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={handleChange}
        closeMenuOnSelect={false}
        hideSelectedOptions={true} 
        styles={{
          control: (base) => ({
            ...base,
            borderColor: errors?.[name] ? "#e85347" : "#ccc",
          }),
        }}
      />

      {errors?.[name] && (
        <span style={{ color: "#e85347", fontSize: "11px", fontStyle: "italic" }}>
          {errors[name]?.message}
        </span>
      )}
    </div>
  );
};

export default MultiSelect;